import PropTypes from 'prop-types';
import React from "react";
import FooterPageLayout from "~app/components/layouts/FooterPageLayout";
import { useT } from '~app/BundleProvider';
import {StyledText} from '~app/StyledText';

  //format={{Link: () => ({style: commonStyles.montserratLight}),}}

const About = ({ mainRef }) => {
  const t = useT();
  return (
    <FooterPageLayout mainRef={mainRef}>
      <article>  
        <h1>{t("about")}</h1>
        <span
          dangerouslySetInnerHTML={{
              __html: t("about-description"),
          }}
        />
        <p>
          <StyledText
            value={t('about-link-help')}
            format={{Link: () => '' }}
          />
        </p>
        <h2>{t("credits")}</h2>
        <span
          dangerouslySetInnerHTML={{
              __html: t("credits-description"),
          }}
        />
        <p>
          <strong>{t("produced-by")}</strong>
        </p>
        <p>
          Jessica Bean, PhD, UCMP, UC Berkeley
          <br />
          Mark Nielsen, PhD, HHMI
        </p>
        <p>
          <strong>{t("design-development")}</strong>
        </p>
        <p>
          Joan Severson, Digital Artefacts
          <br />
          Allen Best, Digital Artefacts
          <br />
          Katelyn McDonald, MA-CMI, Digital Artefacts
          <br />
          Dan Amato, Digital Artefacts
          <br />
          Rick Vanderleest, Digital Artefacts
          <br />
          Kevin Waddle, Digital Artefacts
          <br />
          Mir Rahsinul Mulk, Digital Artefacts
        </p>
        <p>
          <strong>{t("reviewers-editors")}</strong>
        </p>
        <p>
          Anastasia Thanukos, PhD, UCMP
          <br />
          Charles R. Marshall, PhD, UCMP
          <br />
          Lisa White, PhD, UCMP
          <br />
          Paul Beardsley, PhD, HHMI/Cal Poly Pomona
          <br />
          Laura Bonetta, PhD, HHMI
          <br />
          Kim Parfitt
          <br />
          Karen Lucci
          <br />
          Annie Prud’homme-Genereux
          <br />
          Ryan Reardon
        </p>    
        <p>
          <strong>{t("spanish-translators")}</strong>
        </p>
        <p>
          Have it Translated, compañía de traducción
          <br />
          University of California Museum of Paleontology, UC Berkeley
        </p>
        <p>
          <strong>{t("spanish-editors")}</strong>
        </p>
        <p>
          Mónica Ponce Valadez, PhD, B@UNAM
          <br />
          Isabel Parés Ramos, MS, Urbánica P.C.
          <br />
          Jamillah Echeverria, Vialux Media
          <br />
          Zulmarie Pérez Horta, PhD, HHMI
        </p>
        <p>
          {t("version")}
          <br />
          30/4/2020
        </p>
      </article>
    </FooterPageLayout>
  );
};

About.propTypes = {
  mainRef: PropTypes.func.isRequired,
};

export default About;



// WEBPACK FOOTER //
// ./src/pages/About.js